import React from 'react';
import { useAuth } from '@/lib/auth';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { ThemeSegmented } from '@/components/ThemeToggle';

export const ProfilePage: React.FC = () => {
  const { user, role } = useAuth();
  if (!user) return null;
  return (
    <div className="space-y-6 animate-fade-in">
      <h2 className="font-headline text-3xl text-raptor-navy tracking-wide">My profile</h2>
      <Card>
        <CardHeader><CardTitle>{user.full_name}</CardTitle><CardDescription>{user.email}</CardDescription></CardHeader>
        <CardContent>
          <dl className="grid grid-cols-2 gap-3 text-sm font-body">
            <dt className="text-raptor-navy/60">Role</dt><dd><Badge variant="blue">{role?.name}</Badge></dd>
            <dt className="text-raptor-navy/60">Context</dt><dd className="font-tabular">{user.context}</dd>
            <dt className="text-raptor-navy/60">Insurer</dt><dd className="font-tabular">{user.insurer_id ?? '—'}</dd>
            <dt className="text-raptor-navy/60">Broker</dt><dd className="font-tabular">{user.broker_id ?? '—'}</dd>
            <dt className="text-raptor-navy/60">2FA</dt><dd>{user.twofa_enabled ? <Badge variant="success">Enabled</Badge> : <Badge variant="muted">Disabled</Badge>}</dd>
            <dt className="text-raptor-navy/60">Last login</dt><dd className="font-tabular text-xs">{user.last_login_at ?? 'Never'}</dd>
          </dl>
        </CardContent>
      </Card>
      <Card>
        <CardHeader><CardTitle>Appearance</CardTitle><CardDescription>Choose how RAPTOR looks on this device.</CardDescription></CardHeader>
        <CardContent><ThemeSegmented /></CardContent>
      </Card>
    </div>
  );
};
